// Import model
import { FilterEstimateOptionsRequest } from '../models/FilterEstimateOptionsRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { EstimateOptionsCondition } from '../models/EstimateOptionsCondition';
import { EstimateOptionsFields } from '../models/EstimateOptionsFields';
import { EstimateOptionsIndexedFields } from '../models/EstimateOptionsIndexedFields';

// Import dependency serializers (for complex types)
import { EstimateOptionsConditionSerializer } from './EstimateOptionsConditionSerializer';
import { EstimateOptionsFieldsSerializer } from './EstimateOptionsFieldsSerializer';
import { EstimateOptionsIndexedFieldsSerializer } from './EstimateOptionsIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterEstimateOptionsRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterEstimateOptionsRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterEstimateOptionsRequest instance
   */
  static deserialize(json: string): FilterEstimateOptionsRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterEstimateOptionsRequest instance
   */
  static fromObject(obj: any): FilterEstimateOptionsRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterEstimateOptionsRequest');
    }


    const instance: FilterEstimateOptionsRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as EstimateOptionsIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as EstimateOptionsFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        EstimateOptionsConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterEstimateOptionsRequest instances
   */
  static deserializeArray(json: string): FilterEstimateOptionsRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterEstimateOptionsRequest instance to a JSON string
   */
  static serialize(instance: FilterEstimateOptionsRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterEstimateOptionsRequest instance to a plain object
   */
  static toObject(instance: FilterEstimateOptionsRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        EstimateOptionsConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterEstimateOptionsRequest instances to a JSON string
   */
  static serializeArray(instances: FilterEstimateOptionsRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
